import React from 'react'
import { useATTrackInteraction } from '@at/consumer-web-snowplow'
import { useSearchViewState } from '../../contexts/search-view-state-context'
import { useFormState } from '../../forms/hocs/form.state'
import { FacetGroupName } from '../../__generated__/fed-graphql-types'
import { filterModalPopupDelay } from '../expandable-filter/expandable-filter'
import { StyledATDSPill } from './filter-button.styles'

export const SuggestedFacetButton = ({ text, facetGroupName }: { text?: string; facetGroupName: FacetGroupName }) => {
    const { toggleSearchFilter } = useSearchViewState()
    const { expandFilterGroup } = useFormState()

    const handleTrackingInteraction = useATTrackInteraction({
        trackingLabel: `suggested-filter-pill-${facetGroupName.replace(/_/g, '-')}`,
    })

    const id = `search-filter-toggle-${facetGroupName}`
    const showNewBadge = facetGroupName === FacetGroupName.category_tag

    return (
        <StyledATDSPill
            displayType="add"
            onInteraction={() => {
                handleTrackingInteraction()
                expandFilterGroup(facetGroupName)
                toggleSearchFilter(true)
                setTimeout(() => {
                    const scrollFilter = document.getElementById(facetGroupName)
                    scrollFilter && scrollFilter.scrollIntoView({ behavior: 'instant' })
                }, filterModalPopupDelay + 1)
            }}
            data-testid={id}
            text={text}
            showAddIcon={false}
            $showNewBadge={showNewBadge}
        />
    )
}
